export const NameMaxLength = 50;
export const EmailMaxLength = 255;
export const LabelMaxLength = 255;
export const ValueMaxLength = 255;
